import gql from 'graphql-tag';

export default gql`
  mutation RemoveHba1cMeasurementMutation($request: HbA1cTestRemoveInputType!) {
    diabetes {
      HbA1cTestRemove(testRemoveData: $request) {
        __typename
        ... on BasicMutationSuccess {
          successCode: code
        }
        ... on UnauthorizedException {
          unauthorizedCode: code
        }
        ... on ValidationException {
          validationCode: code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
